import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import * as React from 'react';
import axios from "axios";

import { styled } from '@mui/material/styles';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Rating from '@mui/material/Rating';
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import CircularProgress from '@mui/material/CircularProgress';
import useMediaQuery from '@mui/material/useMediaQuery';
import Link from '@mui/material/Link';
import Breadcrumbs from '@mui/material/Breadcrumbs';

import isEmail from 'validator/lib/isEmail';
import isStrongPassword from 'validator/lib/isStrongPassword';
import isLength from 'validator/lib/isLength';
import equals from 'validator/lib/equals';
import dayjs from 'dayjs'

import { Swiper } from 'swiper/react';
import { SwiperSlide } from 'swiper/react';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import "./../assets/swiperCss.css";
import 'swiper/css/autoplay';

import AdminMenuComponent from "../../components/admin/AdminMenuComponent.js";

const widthPageSlide = 600;

const ContattiPageComponent = ({ loginUserApiRequest, reduxDispatch, setReduxUserState }) => {
  const [validated, setValidated] = useState(false);
  const [loginUserResponseState, setLoginUserResponseState] = useState({
    success: "",
    error: "",
    loading: false,
  });

  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");

  const [fieldNameError, setFieldNameError] = useState(false);
  const [fieldLastnameError, setFieldLastnameError] = useState(false);
  const [fieldEmailError, setEmailFieldError] = useState(false);
  const [fieldPasswordError, setFieldPasswordError] = useState(false);

  const [showAlertMessaggioInviato, setShowAlertMessaggioInviato] = useState(false);

  const config = require("../../constants/constants.js")

  const [page, setPage] = useState({});
  const [id, setId] = useState("");
  const [title, setTitle] = useState("");
  const [subTitle, setSubTitle] = useState("");
  const [description, setDescription] = useState("");
  const [customizedName, setCustomizedName] = useState("");
  const [customizedStreet, setCustomizedStreet] = useState("");
  const [customizedZip, setCustomizedZip] = useState("");
  const [customizedCity, setCustomizedCity] = useState("");
  const [customizedEmail, setCustomizedEmail] = useState("");
  const [tabAttivo, setTabAttivo] = React.useState('home');
  const [pathImage1, setPathImage1] = useState("");
  const [pathImage2, setPathImage2] = useState("");
  const [pathImage3, setPathImage3] = useState("");
  const [titleImage1, setTitleImage1] = useState("");
  const [subTitleImage1, setSubTitleImage1] = useState("");
  const [titleImage2, setTitleImage2] = useState("");
  const [subTitleImage2, setSubTitleImage2] = useState("");
  const [titleImage3, setTitleImage3] = useState("");
  const [subTitleImage3, setSubTitleImage3] = useState("");

  const getPageByMenuValueApiRequest = async (menuValue) => {
    console.log("[getPageByMenuValueApiRequest] leggo page con menuValue =", menuValue);
    const url = `/api/pages/menuValue/` + menuValue;
    const { data } = await axios.get(url);
    console.log(`data =`, data);
    return data
  }

  const storeMessaggioApiRequest = async (formInputs) => {
    const { data } = await axios.post(`/api/messages`, { ...formInputs });
    return data;
  };

  const sendEmailContattiApiRequest = async (emailContattiForm) => {
    console.log(' [createEmailContattiApiRequest] emailContattiForm=', emailContattiForm);
    const { data } = await axios.post(`/api/messages/email`, { ...emailContattiForm });
    return data;
  };

  useEffect(() => {
    getPageByMenuValueApiRequest('CONTATTI').then((data) => {
      console.log(`data 1 =`, data);
      setPage(data);
      setTitle(data?.title.text);
      setSubTitle(data?.subTitle.text);
      setDescription(data?.description.text);
      setTabAttivo('home');
      setId(data?._id);
      setPathImage1(data?.images[0].path);
      setPathImage2(data?.images[1].path);
      setPathImage3(data?.images[2].path);
      setCustomizedName(page?.customizedContent.name.text);
      setCustomizedStreet(page?.customizedContent.street.text);
      setCustomizedZip(page?.customizedContent.zip.text);
      setCustomizedCity(page?.customizedContent.city.text);
      setCustomizedEmail(page?.customizedContent.email.text);
      setTitleImage1(data?.imagesTitle[0].text);
      setSubTitleImage1(data?.imagesSubTitle[0].text);
      setTitleImage2(data?.imagesTitle[1].text);
      setSubTitleImage2(data?.imagesSubTitle[1].text);
      setTitleImage3(data?.imagesTitle[2].text);
      setSubTitleImage3(data?.imagesSubTitle[2].text);
      console.log(`id =`, id);
      console.log(`page?.title.text =`, page?.title.text);
      console.log(`page?.description.text =`, page?.description.text);
      console.log(`page?.customizedContent =`, page?.customizedContent);
      console.log(`page?.customizedContent.name.text =`, page?.customizedContent.zip.text);
    })
      .catch((er) => {
        console.log(er);
      });
  }, [tabAttivo, id])

  const [applicativo, setApplicativo] = useState("");
  const [ragioneSociale, setRagioneSociale] = useState("");
  const [indirizzo, setIndirizzo] = useState("");
  const [cap, setCap] = useState("");
  const [citta, setCitta] = useState("");
  const [emailToSendContatti, setEmailToSendContatti] = useState("");
  const [telefonoCallFromSite, setTelefonoCallFromSite] = useState("");
  const [linkWhatsapp, setLinkWhatsapp] = useState("");
  const [linkFacebook, setLinkFacebook] = useState("");
  const [linkInstagram, setLinkInstagram] = useState("");
  const [linkTwitter, setLinkTwitter] = useState("");
  const [linkLinkedin, setLinkLinkedin] = useState("");
  const [urlSiteImageServer, setUrlSiteImageServer] = useState("");
  const [urlCustomerImageServer, setUrlCustomerImageServer] = useState("");

  const getConfigByProgressivoApiRequest = async (progressivoRagSoc) => {
    console.log("[getConfigByProgressivoApiRequest] leggo const con progressivo =", progressivoRagSoc);
    const url = `/api/configs/progressivo/` + progressivoRagSoc;
    const { data } = await axios.get(url);
    return data
  }

  useEffect(() => {
    getConfigByProgressivoApiRequest('0001').then((data) => {
      console.log(`data =`, data);
      setApplicativo(data?.applicativo);
      setRagioneSociale(data?.ragioneSociale);
      setIndirizzo(data?.indirizzo);
      setCap(data?.cap);
      setCitta(data?.citta);
      setEmailToSendContatti(data?.emailToSendContatti)
      setTelefonoCallFromSite("tel:" + data?.telefonoCallFromSite)
      setLinkWhatsapp("https://wa.me/" + data?.linkWhatsapp);
      setLinkFacebook(data?.linkFacebook);
      setLinkInstagram(data?.linkInstagram);
      setLinkTwitter(data?.linkTwitter);
      setLinkLinkedin(data?.linkLinkedin);
      setUrlSiteImageServer(data?.urlSiteImageServer);
      setUrlCustomerImageServer(data?.urlCustomerImageServer);
      console.log(`data?.applicativo =`, data?.applicativo);
      console.log(`data?.emailToSendContatti =`, data?.emailToSendContatti);
      console.log(`data?.linkWhatsapp =`, data?.linkWhatsapp);
      console.log(`data?.linkFacebook =`, data?.linkFacebook);
      console.log(`data?.linkInstagram =`, data?.linkInstagram);
      console.log(`data?.linkTwitter =`, data?.linkTwitter);
      console.log(`ragioneSociale =`, data?.ragioneSociale);
      console.log(`urlCustomerImageServer =`, data?.urlCustomerImageServer);
    })
      .catch((er) => {
        console.log(er);
      });
  }, [ragioneSociale, setEmail, setUrlCustomerImageServer])


  function inviaMessaggio(eventKey) {
    eventKey.preventDefault();
    eventKey.stopPropagation();

    // -- persisto Messaggio ricevuto dal sito
    const formInputs = {
      title: name,
      email: email,
      telephone: phone,
      messageTxt: message,
      note: '',
      day: dayjs(new Date()).format('YYYY-MM-DD'),
      time: dayjs(new Date()).format('HH:mm:ss'),
    };
    storeMessaggioApiRequest(formInputs)

    // -- imvio email Messaggio ricevuto dal sito
    const emailMessageForm =
    {
      title: name,
      email: email,
      telephone: phone,
      messageTxt: message,
      note: '',
      day: dayjs(new Date()).format('YYYY-MM-DD'),
      time: dayjs(new Date()).format('HH:mm:ss'),
      hostTransmitter: "smtp.hostinger.com",
      emailTransmitter: "support@mpmproject.it",
      pswTransmitter: "Supp10mpm!",
      emailToSend: emailToSendContatti,
      applicativo: applicativo,
    };
    sendEmailContattiApiRequest(emailMessageForm);

    setShowAlertMessaggioInviato(true);

    //window.location.assign('/admin/users')
  }

  function closeAlertMessage() {
    setName("");
    setEmail("");
    setPhone("");
    setMessage("");
    setShowAlertMessaggioInviato(false);
    //navigate(1);
  }

  return (

    <Box sx={{ flexGrow: 1 }}>

      <AdminMenuComponent></AdminMenuComponent>

      <Breadcrumbs separator="›" aria-label="breadcrumb"
        size={{ xs: 12, md: 4 }}
        paddingTop={{ xs: 3, md: 3 }}
        paddingLeft={{ xs: 2, md: 6 }}
        paddingRight={{ xs: 1, md: 8 }}
        spacing={{ xs: 2, md: 2 }}
      >
        <Link underline="hover" color="inherit" href="/">
          {config.BC_HOME}
        </Link>
        <Typography sx={{ color: 'text.primary' }}>{config.BC_CONTATTI}</Typography>
      </Breadcrumbs>

      <Grid container spacing={2}>

        <Grid
          size={{ xs: 0, md: 0 }}
        >
        </Grid>

        <Grid
          size={{ xs: 12, md: 5 }}
          padding={{ xs: 0, md: 4 }}
        >

          <Box sx={{ width: { md: widthPageSlide } }}>

            {!useMediaQuery('(min-width:600px)') &&
              <Swiper
                style={{
                  '--swiper-navigation-color': '#fff',
                  '--swiper-pagination-color': '#fff',
                }}

                lazy={true}
                pagination={{
                  clickable: true,
                }}
                navigation={true}
                modules={[Pagination, Navigation]}
                className="image-dim"
              >
                <SwiperSlide>
                  <img
                    src={pathImage1}
                    loading="lazy"
                  />
                  <div class="text-overlay">{titleImage1}</div>
                  <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    src={pathImage2}
                    loading="lazy"
                  />
                  <div class="text-overlay">{titleImage2}</div>
                  <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    src={pathImage3}
                    loading="lazy"
                  />
                  <div class="text-overlay">{titleImage3}</div>
                  <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                </SwiperSlide>
              </Swiper>
            }
            {useMediaQuery('(min-width:600px)') &&
              <Swiper
                style={{
                  '--swiper-navigation-color': '#fff',
                  '--swiper-pagination-color': '#fff',
                }}

                loop={true}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false
                }}

                lazy={true}
                pagination={{
                  clickable: true,
                }}
                navigation={true}
                modules={[Pagination, Navigation, Autoplay]}
                className="image-dim"
              >

                {page.images?.map((itemImg, id) => (

                  <SwiperSlide>
                    <img
                      src={itemImg.path}
                      loading="lazy"
                    />
                    <div class="text-overlay">
                      <p>
                        <Typography variant="h6" color='#ffffff'
                          sx={{
                            paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1,
                            p: 0, m: 0,
                          }}
                        >
                          {itemImg.title}
                        </Typography>
                      </p>
                      <p>
                        <Typography variant="h7" color='#dfdfde'
                          sx={{
                            paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 1,
                            p: 0, m: 0,
                          }}
                        >
                          {itemImg.subTitle}
                        </Typography>
                      </p>
                    </div>
                    <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                  </SwiperSlide>

                ))}

                <SwiperSlide>
                  <img
                    src={pathImage2}
                    loading="lazy"
                  />
                  <div class="text-overlay">
                    <p>
                      <Typography variant="h6" color='#ffffff'
                        sx={{
                          paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1,
                          p: 0, m: 0,
                        }}
                      >
                        {titleImage2}
                      </Typography>
                    </p>
                    <p>
                      <Typography variant="h7" color='#dfdfde'
                        sx={{
                          paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 1,
                          p: 0, m: 0,
                        }}
                      >
                        {subTitleImage2}
                      </Typography>
                    </p>
                  </div>
                  <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                </SwiperSlide>

              </Swiper>
            }

          </Box>

        </Grid>

        <Grid
          size={{ xs: 12, md: 4 }}
          marginLeft={{ xs: 2, md: 6 }}
          paddingTop={{ xs: 0, md: 0 }}
          paddingBottom={{ xs: 0, md: 1 }}
          paddingLeft={{ xs: 0, md: 1 }}
          paddingRight={{ xs: 1, md: 1 }}
          spacing={2}
        >

          <Box
            sx={{
              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
              height: 30
            }}
          />

          <Paper
            sx={{
              paddingTop: 1, paddingBottom: 2, paddingLeft: 2, paddingRight: 2,
              background: '#cce0e6'

            }}
            elevation={6}
          >

            <Typography
              sx={{
                paddingTop: 1, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                fontFamily: 'Arial',
                fontWeight: 500,
                fontSize: 30,
                color: 'navy',
              }}
            >
              <b>{title}</b>
            </Typography>

            <Box
              sx={{
                paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                height: 10
              }}
            />

            <Stack
              sx={{
                flexDirection: { xs: "column", md: "column" },
                paddingTop: 0, paddingBottom: 2, paddingLeft: 2, paddingRight: 1,
              }}
              spacing={1}
            >

              <TextField id="id-name" label="nome e cognome" variant="outlined" defaultValue={name} value={name} required
                error={fieldNameError}
                size="small"
                onChange={(event) => {
                  setName(event.target.value);
                  if (isLength(event.target.value, { min: 3, max: 15 })) {
                    setFieldNameError(false);
                  } else {
                    setFieldNameError(true);
                  }
                }}
              />

              <TextField id="id-email" label="email" variant="outlined" defaultValue={email} value={email} required
                error={fieldEmailError}
                size="small"
                onChange={(event) => {
                  setEmail(event.target.value);
                  if (isEmail(event.target.value)) {
                    setEmailFieldError(false);
                  } else {
                    setEmailFieldError(true);
                  }
                }}
              />

              <TextField id="id-phone" label="telefono" variant="outlined" defaultValue={phone} value={phone}
                size="small"
                onChange={(event) => {
                  setPhone(event.target.value);
                }}
              />

              <TextField id="id-message" label="messaggio" variant="outlined" defaultValue={message} value={message} required
                size="small"
                onChange={(event) => {
                  setMessage(event.target.value);
                }}
                multiline
                rows={3}
                maxRows={6}
              />

            </Stack>

            <Box
              sx={{
                paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                height: 2
              }}
            />

            <Grid
              container
              spacing={1}
              sx={{
                paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 1,
              }}
              justifyContent={"flex-end"}
            >

              <Button
                type="button"
                className="btn btn-primary"
                onClick={(e) => { inviaMessaggio(e); }}
                sx={{ maxWidth: "10ch" }}
                variant="contained"
                style={{
                  display: showAlertMessaggioInviato ? "none" : "block"
                }}
              >
                Invia
              </Button>

            </Grid>

          </Paper>

        </Grid>

        <Dialog open={showAlertMessaggioInviato}>
          <Alert
            variant="filled"
            severity="success"
            dismissible
            onClose={() => closeAlertMessage()}
          >
            <Grid md={4}>
            </Grid>

            <Grid md={8}>

              <Typography sx={{ color: '#ffff', fontSize: 16 }}>
                <Box fontWeight='fontWeightMedium' display='inline' sx={{ fontWeight: 'bold' }} >
                  Messaggio inviato:
                </Box>
                &nbsp;grazie per averci contattato, risponderemo al più presto
              </Typography>
              <Typography>
              </Typography>

            </Grid>

          </Alert>

        </Dialog>

        <Box
          sx={{
            paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
            height: 20
          }}
        />

      </Grid>

      <Box
        sx={{
          paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
          height: 30
        }}
      />

    </Box>

  );
};

export default ContattiPageComponent;
